import { render } from "./ShareLike.vue?vue&type=template&id=13e70062&ts=true"
import script from "./ShareLike.vue?vue&type=script&lang=ts"
export * from "./ShareLike.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__